module.exports = __webpack_public_path__ + "img/Moon.821d7991.png";